var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "便利店" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "批次号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsInNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsInNo", $$v)
                      },
                      expression: "searchInfo.goodsInNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchInfo.auditStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "auditStatus", $$v)
                        },
                        expression: "searchInfo.auditStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "1",
                        attrs: { label: "未提交", value: "1" }
                      }),
                      _c("el-option", {
                        key: "2",
                        attrs: { label: "审核中", value: "2" }
                      }),
                      _c("el-option", {
                        key: "3",
                        attrs: { label: "通过", value: "3" }
                      }),
                      _c("el-option", {
                        key: "4",
                        attrs: { label: "不通过", value: "4" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核时间" } },
                [
                  _c("el-date-picker", {
                    attrs: { type: "datetime", placeholder: "选择日期时间" },
                    model: {
                      value: _vm.searchInfo.auditAtStart,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "auditAtStart", $$v)
                      },
                      expression: "searchInfo.auditAtStart"
                    }
                  }),
                  _vm._v(" - "),
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: "选择日期时间",
                      "default-time": "23:59:59"
                    },
                    model: {
                      value: _vm.searchInfo.auditAtEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "auditAtEnd", $$v)
                      },
                      expression: "searchInfo.auditAtEnd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增入库")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelChange,
            "row-dblclick": _vm.onView
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ID", width: "40", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { label: "入库批次号", prop: "goodsInNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "便利店名称", prop: "sellerId", width: "180px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "入库数量", prop: "goodsNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "成本金额", prop: "goodsAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "商品种类", prop: "categoryNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "是否报销" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          scope.row.isNeedReimburse == 1 ? "需报销" : "不报销"
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "备注", prop: "remark" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.remark))]),
                    scope.row.allocationNo && scope.row.allocationNo != ""
                      ? _c("div", [
                          _vm._v("调拨编号：" + _vm._s(scope.row.allocationNo))
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "审批意见", prop: "auditRemark" }
          }),
          _c("el-table-column", {
            attrs: { label: "审批人", prop: "auditUserName" }
          }),
          _c("el-table-column", {
            attrs: { label: "审批时间", prop: "auditAt" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDateTime")(scope.row.auditAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "审核状态", prop: "auditStatus", width: "80px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", effect: "plain" } },
                          [_vm._v("未提交")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", effect: "plain" } },
                          [_vm._v("审核中")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("通过")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 4
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("不通过")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt", width: "160px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDateTime")(scope.row.CreatedAt))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "240px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onSubmitAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("提审")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onUpdate(scope.row)
                              }
                            }
                          },
                          [_vm._v("变更")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onDelete(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 4
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onCopy(scope.row)
                              }
                            }
                          },
                          [_vm._v("复制")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            title: _vm.type == "view" ? "查看明细" : "审核操作",
            visible: _vm.viewAndAuditdialogVisible,
            "custom-class": "bairun-dialog bairun-dialog-large",
            "before-close": _vm.closeDialog,
            "element-loading-text": _vm.loadingText,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "#0000004d"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewAndAuditdialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { staticClass: "bairun-dialog-table bairun-dialog-goodsin-table" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsInTableView,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "序号", width: "50" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "便利店名称", prop: "sellerId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getSellerName")(scope.row.sellerId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "入库批次号", prop: "goodsInNo" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "供应商", prop: "supplierNo" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getSupplierName")(scope.row.supplierNo)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "条形码", prop: "goodsNo" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "入库数量", prop: "goodsInNum" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本总金额", prop: "goodsInAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本单价", prop: "goodsCost" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销售单价", prop: "goodsPrice" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "有效期开始",
                      prop: "dateStart",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.dateStart))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "有效期结束",
                      prop: "dateEnd",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.dateEnd))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "入库时间",
                      prop: "CreatedAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDateTime")(scope.row.CreatedAt)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.type == "audit"
            ? _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("span", { staticClass: "goodsin-summary" }, [
                      _c("label", [
                        _vm._v("入库总数量：" + _vm._s(_vm.goodsinNumSummary))
                      ]),
                      _c("label", [
                        _vm._v(
                          "入库总成本金额：" + _vm._s(_vm.goodsinAmountSummary)
                        )
                      ])
                    ])
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "auditForm",
                          staticStyle: { "margin-bottom": "15px" },
                          attrs: {
                            model: _vm.formData,
                            rules: _vm.auditRules,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审批意见:",
                                    prop: "auditRemark"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      clearable: "",
                                      placeholder: "请输入"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审批结果:",
                                    prop: "auditStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择"
                                      },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        key: "3",
                                        attrs: { label: "通过", value: "3" }
                                      }),
                                      _c("el-option", {
                                        key: "4",
                                        attrs: { label: "不通过", value: "4" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 4 }
                    },
                    [
                      _c("el-button", { on: { click: _vm.closeDialog } }, [
                        _vm._v("取 消")
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onAuditSubmit }
                        },
                        [_vm._v("确定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.type == "view"
            ? _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("span", { staticClass: "goodsin-summary" }, [
                      _c("label", [
                        _vm._v("入库总数量：" + _vm._s(_vm.goodsinNumSummary))
                      ]),
                      _c("label", [
                        _vm._v(
                          "入库总成本金额：" + _vm._s(_vm.goodsinAmountSummary)
                        )
                      ])
                    ])
                  ]),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 16 }
                    },
                    [
                      _c("el-button", { on: { click: _vm.closeDialog } }, [
                        _vm._v("取 消")
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.closeDialog }
                        },
                        [_vm._v("确定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            title:
              _vm.type === "add"
                ? "新增入库"
                : _vm.type === "update"
                ? "变更操作"
                : "",
            visible: _vm.addDialogVisible,
            "custom-class": "bairun-dialog bairun-dialog-large",
            "before-close": _vm.closeDialog,
            "element-loading-text": _vm.loadingText,
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "#0000004d"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "bairun-select-large bairun-required",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "选择商店"
                      },
                      model: {
                        value: _vm.goodsSellerId,
                        callback: function($$v) {
                          _vm.goodsSellerId = $$v
                        },
                        expression: "goodsSellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "bairun-select-large bairun-required",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "选择供应商"
                      },
                      model: {
                        value: _vm.supplierNo,
                        callback: function($$v) {
                          _vm.supplierNo = $$v
                        },
                        expression: "supplierNo"
                      }
                    },
                    _vm._l(_vm.supplierOptions, function(item) {
                      return _c("el-option", {
                        key: item.supplierNo,
                        attrs: { label: item.name, value: item.supplierNo }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "goodsSearchSelect",
                      staticClass: "bairun-select-large",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: "扫商品条形码或输入商品名搜索",
                        "remote-method": _vm.goodsSearch,
                        loading: _vm.goodsLoading,
                        disabled: _vm.goodsSellerId == ""
                      },
                      on: { change: _vm.onGoodsSel },
                      model: {
                        value: _vm.spuNo,
                        callback: function($$v) {
                          _vm.spuNo = $$v
                        },
                        expression: "spuNo"
                      }
                    },
                    _vm._l(_vm.goodsOptions, function(item) {
                      return _c(
                        "el-option",
                        {
                          key: item.spuNo,
                          attrs: { label: item.goodsName, value: item.spuNo }
                        },
                        [
                          _c("span", [
                            _vm._v("商品名称："),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  color: "red"
                                }
                              },
                              [_vm._v(_vm._s(item.goodsName))]
                            )
                          ]),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "15px" } },
                            [
                              _vm._v("库存："),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    color: "red"
                                  }
                                },
                                [_vm._v(_vm._s(item.goodsStock))]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "15px" } },
                            [
                              _vm._v("规格："),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(item.goodsSpecification))]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "15px" } },
                            [
                              _vm._v("单位："),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(item.goodsUnit))]
                              )
                            ]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "15px" } },
                            [
                              _vm._v("类目："),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(item.categoryName))]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    staticClass: "bairun-input-large",
                    attrs: { type: "text", placeholder: "备注", clearable: "" },
                    on: {
                      input: function($event) {
                        return _vm.inputChange($event)
                      }
                    },
                    model: {
                      value: _vm.goodsRemark,
                      callback: function($$v) {
                        _vm.goodsRemark = $$v
                      },
                      expression: "goodsRemark"
                    }
                  })
                ],
                1
              ),
              _c("el-col", { attrs: { span: 2 } }, [
                _c(
                  "div",
                  [
                    _vm._v("自动计算："),
                    _c("el-switch", {
                      attrs: { "active-color": "#cf9236" },
                      model: {
                        value: _vm.swichAuto,
                        callback: function($$v) {
                          _vm.swichAuto = $$v
                        },
                        expression: "swichAuto"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "15px" } },
                  [
                    _vm._v("是否报销："),
                    _c("el-switch", {
                      attrs: { "active-color": "#cf9236" },
                      model: {
                        value: _vm.isNeedReimburse,
                        callback: function($$v) {
                          _vm.isNeedReimburse = $$v
                        },
                        expression: "isNeedReimburse"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "bairun-dialog-table", attrs: { gutter: 20 } },
            [
              _c(
                "el-table",
                {
                  ref: "goodsInTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsInTableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "序号", width: "50" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "便利店名称", prop: "sellerId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getSellerName")(scope.row.sellerId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "供应商", prop: "supplierNo" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticClass:
                                  "bairun-select-large bairun-required",
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: ""
                                },
                                model: {
                                  value: scope.row.supplierNo,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "supplierNo", $$v)
                                  },
                                  expression: "scope.row.supplierNo"
                                }
                              },
                              _vm._l(_vm.supplierOptions, function(item) {
                                return _c("el-option", {
                                  key: item.supplierNo,
                                  attrs: {
                                    label: item.name,
                                    value: item.supplierNo
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "条形码", prop: "goodsNo" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.hasGoodsNo
                              ? _c("div", [_vm._v(_vm._s(scope.row.goodsNo))])
                              : _c("el-input", {
                                  staticClass:
                                    "bairun-input-fill bairun-required",
                                  staticStyle: { height: "47px" },
                                  attrs: {
                                    type: "text",
                                    placeholder: "请扫描",
                                    clearable: ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.inputChange($event)
                                    }
                                  },
                                  model: {
                                    value: scope.row.goodsNo,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "goodsNo", $$v)
                                    },
                                    expression: "scope.row.goodsNo"
                                  }
                                })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "入库数量", prop: "goodsStock" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input-number", {
                              staticClass: "bairun-input-fill bairun-required",
                              staticStyle: { height: "47px" },
                              attrs: {
                                placeholder: "数量",
                                "controls-position": "right",
                                min: 0,
                                max: 999999999999,
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInputGoodsinNum(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.goodsInNum,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goodsInNum", $$v)
                                },
                                expression: "scope.row.goodsInNum"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本总金额", prop: "goodsInAmount" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              staticClass: "bairun-input-fill bairun-required",
                              staticStyle: { height: "47px" },
                              attrs: {
                                type: "text",
                                placeholder: "总金额",
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInputGoodsinAmount(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.goodsInAmount,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goodsInAmount", $$v)
                                },
                                expression: "scope.row.goodsInAmount"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本单价", prop: "goodsCost" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              staticClass: "bairun-input-fill bairun-required",
                              staticStyle: { height: "47px" },
                              attrs: {
                                type: "text",
                                placeholder: "成本价",
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInputGoodsinNum(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.goodsCost,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goodsCost", $$v)
                                },
                                expression: "scope.row.goodsCost"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销售单价", prop: "goodsPrice" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              staticClass: "bairun-input-fill bairun-required",
                              staticStyle: { height: "47px" },
                              attrs: {
                                type: "text",
                                placeholder: "销售价",
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.inputChange($event)
                                }
                              },
                              model: {
                                value: scope.row.goodsPrice,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "goodsPrice", $$v)
                                },
                                expression: "scope.row.goodsPrice"
                              }
                            }),
                            scope.row.goodsPriceText == "最新销售价"
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      right: "10px",
                                      top: "8px"
                                    },
                                    attrs: { size: "mini" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row.goodsPriceText) +
                                        "：" +
                                        _vm._s(scope.row.goodsPrice) +
                                        "元"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            scope.row.goodsPriceText == "销售指导价"
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      right: "10px",
                                      top: "8px"
                                    },
                                    attrs: { size: "mini", type: "warning" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row.goodsPriceText) +
                                        "：" +
                                        _vm._s(scope.row.goodsPrice) +
                                        "元"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "有效期开始", prop: "dateStart" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-date-picker", {
                              staticClass: "bairun-input-fill",
                              staticStyle: { height: "47px" },
                              attrs: {
                                type: "date",
                                clearable: "",
                                placeholder: "必填"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onInputGoodsValidDay(scope.row)
                                }
                              },
                              model: {
                                value: scope.row.dateStart,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "dateStart", $$v)
                                },
                                expression: "scope.row.dateStart"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "保质期" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-input",
                              {
                                staticClass: "bairun-input-fill goods-validday",
                                staticStyle: { height: "47px" },
                                attrs: { placeholder: "非必填" },
                                on: {
                                  blur: function($event) {
                                    return _vm.onInputGoodsValidDay(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.validDay,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "validDay", $$v)
                                  },
                                  expression: "scope.row.validDay"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      slot: "prepend",
                                      placeholder: "请选择"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onInputGoodsValidDay(
                                          scope.row
                                        )
                                      }
                                    },
                                    slot: "prepend",
                                    model: {
                                      value: scope.row.validDayType,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "validDayType", $$v)
                                      },
                                      expression: "scope.row.validDayType"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "天", value: "1" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "月", value: "2" }
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "年", value: "3" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "有效期结束", prop: "dateEnd" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-date-picker", {
                              staticClass: "bairun-input-fill",
                              staticStyle: { height: "47px" },
                              attrs: {
                                type: "date",
                                clearable: "",
                                placeholder: "必填"
                              },
                              model: {
                                value: scope.row.dateEnd,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "dateEnd", $$v)
                                },
                                expression: "scope.row.dateEnd"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "60px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-close",
                                size: "mini",
                                circle: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onDelGoods(scope.row)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", { staticClass: "goodsin-summary" }, [
                _c("label", [
                  _vm._v("入库总数量：" + _vm._s(_vm.goodsinNumSummary))
                ]),
                _c("label", [
                  _vm._v("入库总成本金额：" + _vm._s(_vm.goodsinAmountSummary))
                ])
              ]),
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c("el-button", { on: { click: _vm.onClearGoodsIn } }, [
                _vm._v("清空")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.addSPUDialogFormData.dialogVisible
        ? _c("AddSPUDialog", {
            ref: "AddSPUDialog",
            attrs: {
              "hide-items": ["goodsOfficialPrice"],
              "add-s-p-u-dialog-form-data": _vm.addSPUDialogFormData
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }